import { VueModule } from '@Foundation/utilities';
import Loader from './code/Scripts/components/loader';

export default VueModule({
  components: {
    Loader
  }
});
